var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade show",
      staticStyle: { display: "block" },
      attrs: {
        id: "go-modal-goover-create-step-1",
        tabindex: "-1",
        "aria-hidden": "true",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog go-modal-goover-create" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("div", { staticClass: "go-text-wrap" }, [
              _c("div", { staticClass: "modal-title" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("briefing.popup.updateBriefing.briefingPart.title")
                  )
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn go-btn-icon close",
                attrs: { type: "button", "data-dismiss": "modal" },
                on: { click: _vm.handleCloseModalUpdateBriefingPage },
              },
              [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _c(
              "div",
              { staticClass: "go-block-wrap" },
              [
                _c(
                  "vue-custom-scrollbar",
                  { staticClass: "go-modal-inner scroll-area" },
                  [
                    _c("div", { staticClass: "go-block-body" }, [
                      _c("div", { staticClass: "go-list-content form" }, [
                        _c("div", { staticClass: "go-form-group" }, [
                          _c("label", { staticClass: "go-form-label" }, [
                            _vm._v(_vm._s(_vm.$t("cdHome.t148")) + " "),
                            _c("sup", [_vm._v("*")]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "go-input-group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.title,
                                  expression: "title",
                                },
                              ],
                              staticClass: "go-form-control",
                              attrs: { type: "text", maxlength: "100" },
                              domProps: { value: _vm.title },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.title = $event.target.value
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("small", { staticClass: "go-form-help" }, [
                            _vm._v(_vm._s(_vm.title.length) + " / 100"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("hr", { staticClass: "hr-2" }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "go-form-group data-source" },
                          [
                            _c("label", { staticClass: "go-form-label" }, [
                              _vm._v(_vm._s(_vm.$t("cdHome.t149"))),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "go-nav-select-list" }, [
                              _c("ul", [
                                _c(
                                  "li",
                                  {
                                    class: { noInteraction: _vm.isLoading },
                                    on: {
                                      click: function ($event) {
                                        return _vm.changeDataSource("BASIC")
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "custom-control custom-checkbox",
                                      },
                                      [
                                        _c("input", {
                                          staticClass:
                                            "custom-control-input noInteraction",
                                          attrs: {
                                            type: "checkbox",
                                            id: "sourceCheck1",
                                            disabled: _vm.isLoading,
                                          },
                                          domProps: {
                                            checked:
                                              _vm.dataSources.includes("BASIC"),
                                          },
                                          on: {
                                            click: [
                                              function ($event) {
                                                $event.preventDefault()
                                              },
                                              function ($event) {
                                                $event.stopPropagation()
                                              },
                                            ],
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("label", {
                                          staticClass: "custom-control-label",
                                          attrs: { for: "sourceCheck1" },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("p", [
                                      _c("strong", [
                                        _c("em", [
                                          _vm._v(_vm._s(_vm.$t("cdHome.t39"))),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.$t("cdHome.t40"))),
                                      ]),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  {
                                    class: { noInteraction: _vm.isLoading },
                                    on: {
                                      click: function ($event) {
                                        return _vm.changeDataSource("FINANCE")
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "custom-control custom-checkbox",
                                      },
                                      [
                                        _c("input", {
                                          staticClass:
                                            "custom-control-input noInteraction",
                                          attrs: {
                                            type: "checkbox",
                                            id: "sourceCheck2",
                                            disabled: _vm.isLoading,
                                          },
                                          domProps: {
                                            checked:
                                              _vm.dataSources.includes(
                                                "FINANCE"
                                              ),
                                          },
                                          on: {
                                            click: [
                                              function ($event) {
                                                $event.preventDefault()
                                              },
                                              function ($event) {
                                                $event.stopPropagation()
                                              },
                                            ],
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("label", {
                                          staticClass: "custom-control-label",
                                          attrs: { for: "sourceCheck2" },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("p", [
                                      _c("strong", [
                                        _c("em", [
                                          _vm._v(_vm._s(_vm.$t("cdHome.t21"))),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.$t("cdHome.t22"))),
                                      ]),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  {
                                    class: { noInteraction: _vm.isLoading },
                                    on: {
                                      click: function ($event) {
                                        return _vm.changeDataSource("RND")
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "custom-control custom-checkbox",
                                      },
                                      [
                                        _c("input", {
                                          staticClass:
                                            "custom-control-input noInteraction",
                                          attrs: {
                                            type: "checkbox",
                                            id: "sourceCheck3",
                                            disabled: _vm.isLoading,
                                          },
                                          domProps: {
                                            checked:
                                              _vm.dataSources.includes("RND"),
                                          },
                                          on: {
                                            click: [
                                              function ($event) {
                                                $event.preventDefault()
                                              },
                                              function ($event) {
                                                $event.stopPropagation()
                                              },
                                            ],
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("label", {
                                          staticClass: "custom-control-label",
                                          attrs: { for: "sourceCheck3" },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("p", [
                                      _c("strong", [
                                        _c("em", [
                                          _vm._v(_vm._s(_vm.$t("cdHome.t23"))),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.$t("cdHome.t24"))),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("ul", [
                                _c(
                                  "li",
                                  {
                                    class: { noInteraction: _vm.isLoading },
                                    on: {
                                      click: function ($event) {
                                        return _vm.changeDataSource("PATENT")
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "custom-control custom-checkbox",
                                      },
                                      [
                                        _c("input", {
                                          staticClass:
                                            "custom-control-input noInteraction",
                                          attrs: {
                                            type: "checkbox",
                                            id: "sourceCheck4",
                                            disabled: _vm.isLoading,
                                          },
                                          domProps: {
                                            checked:
                                              _vm.dataSources.includes(
                                                "PATENT"
                                              ),
                                          },
                                          on: {
                                            click: [
                                              function ($event) {
                                                $event.preventDefault()
                                              },
                                              function ($event) {
                                                $event.stopPropagation()
                                              },
                                            ],
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("label", {
                                          staticClass: "custom-control-label",
                                          attrs: { for: "sourceCheck4" },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("p", [
                                      _c("strong", [
                                        _c("em", [
                                          _vm._v(_vm._s(_vm.$t("cdHome.t25"))),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.$t("cdHome.t26"))),
                                      ]),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  {
                                    class: { noInteraction: _vm.isLoading },
                                    on: {
                                      click: function ($event) {
                                        return _vm.changeDataSource("LAW")
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "custom-control custom-checkbox",
                                      },
                                      [
                                        _c("input", {
                                          staticClass:
                                            "custom-control-input noInteraction",
                                          attrs: {
                                            type: "checkbox",
                                            id: "sourceCheck5",
                                            disabled: _vm.isLoading,
                                          },
                                          domProps: {
                                            checked:
                                              _vm.dataSources.includes("LAW"),
                                          },
                                          on: {
                                            click: [
                                              function ($event) {
                                                $event.preventDefault()
                                              },
                                              function ($event) {
                                                $event.stopPropagation()
                                              },
                                            ],
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("label", {
                                          staticClass: "custom-control-label",
                                          attrs: { for: "sourceCheck5" },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("p", [
                                      _c("strong", [
                                        _c("em", [
                                          _vm._v(_vm._s(_vm.$t("cdHome.t27"))),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.$t("cdHome.t28"))),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("hr", { staticClass: "hr-2" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "go-form-group" }, [
                          _c("label", { staticClass: "go-form-label" }, [
                            _vm._v(_vm._s(_vm.$t("cdHome.t125")) + " "),
                            _c("sup", [_vm._v("*")]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "go-block-between" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.reportTypeForUI,
                                    expression: "reportTypeForUI",
                                  },
                                ],
                                staticClass: "go-form-control",
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.reportTypeForUI = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                },
                              },
                              [
                                _c("option", { attrs: { value: "DAILY" } }, [
                                  _vm._v(_vm._s(_vm.$t("cdHome.t126"))),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "option",
                                  { attrs: { value: "PRODUCT_REVIEW" } },
                                  [_vm._v(_vm._s(_vm.$t("cdHome.t128")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "option",
                                  { attrs: { value: "INVESTMENT" } },
                                  [_vm._v(_vm._s(_vm.$t("cdHome.t127")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "option",
                                  { attrs: { value: "INDEPTH_DAILY" } },
                                  [_vm._v(_vm._s(_vm.$t("cdHome.t129")))]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedReportStyle,
                                    expression: "selectedReportStyle",
                                  },
                                ],
                                staticClass: "go-form-control",
                                attrs: {
                                  disabled:
                                    _vm.selectedReportType === "INDEPTH_DAILY",
                                },
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.selectedReportStyle = $event.target
                                      .multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                },
                              },
                              _vm._l(_vm.reportStyles, function (style) {
                                return _c(
                                  "option",
                                  {
                                    key: style.value,
                                    domProps: { value: style.value },
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(style.label) +
                                        "\n                      "
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "go-form-group" }, [
                          _c("label", { staticClass: "go-form-label" }, [
                            _vm._v(_vm._s(_vm.$t("cdHome.t132"))),
                          ]),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.promptReportFocus,
                                expression: "promptReportFocus",
                              },
                            ],
                            staticClass: "go-form-control",
                            attrs: {
                              rows: "3",
                              placeholder: _vm.$t("cdHome.t133"),
                              maxlength: "1000",
                            },
                            domProps: { value: _vm.promptReportFocus },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.promptReportFocus = $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("small", { staticClass: "go-form-help" }, [
                            _vm._v(
                              _vm._s(_vm.promptReportFocus.length) + " / 1000"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "go-form-feedback-help",
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("cdHome.t134")),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("hr", { staticClass: "hr-2" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "go-form-group" }, [
                          _c("div", { staticClass: "go-block-between" }, [
                            _c("label", { staticClass: "go-form-label" }, [
                              _vm._v(_vm._s(_vm.$t("cdHome.t56"))),
                              _c("sup", [_vm._v("*")]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "go-info-inline" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "custom-control custom-radio go-form-check-inline",
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.privacy,
                                        expression: "privacy",
                                      },
                                    ],
                                    staticClass: "custom-control-input",
                                    attrs: {
                                      type: "radio",
                                      id: "go-option-public",
                                      name: "briefingPublicPrivate",
                                      value: "PUBLIC",
                                    },
                                    domProps: {
                                      checked: _vm._q(_vm.privacy, "PUBLIC"),
                                    },
                                    on: {
                                      change: function ($event) {
                                        _vm.privacy = "PUBLIC"
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "custom-control-label",
                                      attrs: { for: "go-option-public" },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("cdHome.t144")))]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "custom-control custom-radio go-form-check-inline",
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.privacy,
                                        expression: "privacy",
                                      },
                                    ],
                                    staticClass: "custom-control-input",
                                    attrs: {
                                      type: "radio",
                                      id: "go-option-private",
                                      name: "briefingPublicPrivate",
                                      value: "PRIVATE",
                                    },
                                    domProps: {
                                      checked: _vm._q(_vm.privacy, "PRIVATE"),
                                    },
                                    on: {
                                      click: _vm.handlePrivacyClick,
                                      change: function ($event) {
                                        _vm.privacy = "PRIVATE"
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "custom-control-label",
                                      attrs: { for: "go-option-private" },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("cdHome.t145")))]
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn go-btn-default go-btn-lg",
                attrs: { type: "button" },
                on: { click: _vm.handleCloseModalUpdateBriefingPage },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$t(
                        "briefing.popup.updateBriefing.footer.cancelButtonText"
                      ) || "Cancel"
                    ) +
                    "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn go-btn-primary go-btn-lg",
                attrs: {
                  type: "button",
                  disabled:
                    _vm.isLoading || !_vm.title || !_vm.reportTypesResult[0],
                },
                on: { click: _vm.handleUpdateBriefing },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$t(
                        "briefing.popup.updateBriefing.footer.saveButtonText"
                      ) || "Save"
                    ) +
                    "\n        "
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }